module.exports = __webpack_public_path__ + "static/media/8200.467fd516.jpg";